import {WarningOutlined} from '@ant-design/icons';
import React from 'react';
import styles from './index.module.scss';

export const Error: React.FC = () => {
  return (
    <div className={styles.sidebarError}>
      <WarningOutlined />
      <h3>An error has occurred, please try again later.</h3>
    </div>
  );
};
